<dx-form labelMode="floating" labelLocation="top" [formData]="SallaryForm" [showColonAfterLabel]="true"
  [showValidationSummary]="true" #formRef style="width: 100%; padding: 1rem 2rem; margin: 2rem 0rem;"
  [rtlEnabled]="currentLang == 'ar' ? true : false">

  <dxo-col-count-by-screen [xs]="1" [sm]="1" [md]="4" [lg]="4"></dxo-col-count-by-screen>

  <dxi-item itemType="group" caption="{{'Store.items.basicinfo' | translate}}" [colCount]="3" [colSpan]="4">

    <!-- Month Selection -->
    <dxi-item [colSpan]="4">
      <app-monthselect (dateRangeChanged)="datechanged($event)" [selectedMonth]="monthFromParent"
        [selectedYear]="yearFromParent">
      </app-monthselect>
      <dx-validator [validationRules]="[{ type: 'required', message: 'الشهر مطلوب' }]"></dx-validator>
    </dxi-item>

    <!-- Registration Date -->
    <dxi-item dataField="registrationDate" [colSpan]="4" editorType="dxDateBox"
      [editorOptions]="{ value: currentDate, displayFormat: 'dd/MM/yyyy' }">
      <dxo-label template="{{'salary.registrationDate' | translate}}"></dxo-label>
    </dxi-item>

    <!-- Exchange Date -->
    <dxi-item dataField="exchangeDate" [colSpan]="4" editorType="dxDateBox"
      [editorOptions]="{ value: currentDate, displayFormat: 'dd/MM/yyyy'}">
      <dxo-label template="{{'salary.exchangeDate' | translate}}"></dxo-label>
    </dxi-item>

    <!-- From Date (Hidden) -->
    <dxi-item dataField="fromDate" [colSpan]="4" editorType="dxDateBox" [visible]="false">
      <dxo-label template="{{'salary.fromDate' | translate}}"></dxo-label>
      <dxi-validation-rule type="required" message="{{'errors.namerequired' | translate}}"></dxi-validation-rule>
    </dxi-item>

    <!-- To Date (Hidden) -->
    <dxi-item dataField="toDate" [colSpan]="4" editorType="dxDateBox" [visible]="false">
      <dxo-label template="{{'salary.toDate' | translate}}"></dxo-label>
      <dxi-validation-rule type="required" message="{{'errors.namerequired' | translate}}"></dxi-validation-rule>
    </dxi-item>

    <!-- Salary Type -->
    <dxi-item dataField="salarytype" editorType="dxLookup" [colSpan]="4"
      [editorOptions]="{dataSource: salarytype, displayExpr: 'name', valueExpr: 'code', searchEnabled: true, showClearButton: true}">
      <dxo-label template="{{'tableinfo.salarytype' | translate}}"></dxo-label>
     
    </dxi-item>

    <!-- Branch Selection -->
    <dxi-item dataField="branchIds" [colSpan]="4">
      <dx-drop-down-box [(value)]="selectedBranch" [inputAttr]="{ 'aria-label': 'Branch Information' }"
        valueExpr="id" displayExpr="nameAr" [showClearButton]="true" [dataSource]="branchesdropdown"
        placeholder="{{'choose'| translate}}  {{'basic-info.branch.branchName' | translate}}"
        contentTemplate="branchContentTemplate">
        <div *dxTemplate="let e of 'branchContentTemplate'">
          <dxo-label text="{{'basic-info.branch.branchName' | translate}}"></dxo-label>
          <dx-data-grid [dataSource]="branchesdropdown" keyExpr="id" [remoteOperations]="true" [height]="500"
            [selectedRowKeys]="selectedBranch" [focusedRowEnabled]="true"
            [searchPanel]="{ visible: true, width: 300, placeholder: 'Search...' }" [hoverStateEnabled]="true"
            (onSelectionChanged)="onBranchSelectionChanged($event.selectedRowKeys)"
            [columns]="[{ dataField: 'nameAr', caption: this.translate.instant('basic-info.branch.branchName')}]">
            <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
            <dxo-scrolling mode="virtual"></dxo-scrolling>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
          </dx-data-grid>
        </div>
      </dx-drop-down-box>
    </dxi-item>

    <!-- Job Title Selection -->
    <dxi-item dataField="jobTitleIds" [colSpan]="4">
      <dx-drop-down-box [(value)]="selectedJob" [inputAttr]="{ 'aria-label': 'Job Title Information' }"
        valueExpr="id" displayExpr="nameAr" [showClearButton]="true" [dataSource]="jobTitleDropDown"
        placeholder="{{'choose'| translate}}  {{'salary.jobTitleId' | translate}}"
        contentTemplate="jobContentTemplate">
        <div *dxTemplate="let e of 'jobContentTemplate'">
          <dxo-label template="{{'salary.jobTitleId' | translate}}"></dxo-label>
          <dx-data-grid [dataSource]="jobTitleDropDown" keyExpr="id" [remoteOperations]="true" [height]="500"
            [selectedRowKeys]="selectedJob" [focusedRowEnabled]="true"
            [searchPanel]="{ visible: true, width: 300, placeholder: 'Search...' }" [hoverStateEnabled]="true"
            (onSelectionChanged)="onJobTitleSelectionChanged($event.selectedRowKeys)"
            [columns]="[{ dataField: 'nameAr', caption:this.translate.instant('salary.jobTitleId') }]">
            <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
            <dxo-scrolling mode="virtual"></dxo-scrolling>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
          </dx-data-grid>
        </div>
      </dx-drop-down-box>
    </dxi-item>

    <!-- Management Selection -->
    <dxi-item dataField="managementIds" [colSpan]="4">
      <dx-drop-down-box [(value)]="selectedManagement" [inputAttr]="{ 'aria-label': 'Management Information' }"
        valueExpr="id" displayExpr="nameAr" [showClearButton]="true" [dataSource]="managementDropDown"
        placeholder="{{'choose'|translate}}  {{'salary.management' | translate}}"
        contentTemplate="managementContentTemplate">
        <div *dxTemplate="let e of 'managementContentTemplate'">
          <dxo-label template="{{'salary.management' | translate}}"></dxo-label>
          <dx-data-grid [dataSource]="managementDropDown" keyExpr="id" [remoteOperations]="true" [height]="500"
            [selectedRowKeys]="selectedManagement" [focusedRowEnabled]="true"
            [searchPanel]="{ visible: true, width: 300, placeholder: 'Search...' }" [hoverStateEnabled]="true"
            (onSelectionChanged)="onManagementSelectionChanged($event.selectedRowKeys)"
            [columns]="[{ dataField: 'nameAr', caption: this.translate.instant('salary.management') }]">
            <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
            <dxo-scrolling mode="virtual"></dxo-scrolling>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
          </dx-data-grid>
        </div>
      </dx-drop-down-box>
    </dxi-item>

    <!-- Department Selection -->
    <dxi-item dataField="departmentIds" [colSpan]="4">
      <dx-drop-down-box [(value)]="selectedDepartment" [inputAttr]="{ 'aria-label': 'Department Information' }"
        valueExpr="id" displayExpr="nameAr" [showClearButton]="true" [dataSource]="departmentDropDown"
        placeholder="{{'choose'| translate}}  {{'salary.department' | translate}}"
        contentTemplate="departmentContentTemplate">
        <div *dxTemplate="let e of 'departmentContentTemplate'">
          <dxo-label template="{{'salary.department' | translate}}"></dxo-label>
          <dx-data-grid [dataSource]="departmentDropDown" keyExpr="id" [remoteOperations]="true" [height]="500"
            [selectedRowKeys]="selectedDepartment" [focusedRowEnabled]="true"
            [searchPanel]="{ visible: true, width: 300, placeholder: 'Search...' }" [hoverStateEnabled]="true"
            (onSelectionChanged)="onDepartmentSelectionChanged($event.selectedRowKeys)"
            [columns]="[{ dataField: 'nameAr', caption:this.translate.instant('salary.department') }]">
            <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
            <dxo-scrolling mode="virtual"></dxo-scrolling>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
          </dx-data-grid>
        </div>
      </dx-drop-down-box>
    </dxi-item>

    <!-- Work System Selection -->
    <dxi-item dataField="workSystemIds" [colSpan]="4">
      <dx-drop-down-box [(value)]="selectedWorkSystem" [inputAttr]="{ 'aria-label': 'Work System Information' }"
        valueExpr="id" displayExpr="nameAr" [showClearButton]="true" [dataSource]="WorkSystemDropDown"
        placeholder="{{'choose'|translate}} {{'salary.workSystem' | translate}}"
        contentTemplate="WorkSystemContentTemplate">
        <div *dxTemplate="let e of 'WorkSystemContentTemplate'">
          <dxo-label template="{{'salary.workSystem' | translate}}"></dxo-label>
          <dx-data-grid [dataSource]="WorkSystemDropDown" keyExpr="id" [remoteOperations]="true" [height]="500"
            [selectedRowKeys]="selectedWorkSystem" [focusedRowEnabled]="true"
            [searchPanel]="{ visible: true, width: 300, placeholder: 'Search...' }" [hoverStateEnabled]="true"
            (onSelectionChanged)="onWorkSystemSelectionChanged($event.selectedRowKeys)"
            [columns]="[{ dataField: 'nameAr', caption: this.translate.instant('salary.workSystem') }]">
            <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
            <dxo-scrolling mode="virtual"></dxo-scrolling>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
          </dx-data-grid>
        </div>
      </dx-drop-down-box>
    </dxi-item>

    <!-- Salary Notes -->
    <dxi-item dataField="salaryNotes" [colSpan]="4">
      <dxo-label text="{{'salary.salaryNotes'|translate}}"></dxo-label>
      <dxi-validation-rule  message="{{'errors.namerequired'|translate}}"></dxi-validation-rule>
    </dxi-item>

    <!-- Bank -->
    <dxi-item dataField="bankId" editorType="dxLookup" [colSpan]="4"
      [editorOptions]="{dataSource: bankDropDown, displayExpr: 'nameAr', valueExpr: 'id', searchEnabled: true, showClearButton: true}">
      <dxo-label text="{{'salary.bank' | translate}}"></dxo-label>
    </dxi-item>

  </dxi-item>

  <!-- Employee Selection -->
  <dxi-item dataField="employeeIds" [colSpan]="4">
    <dx-drop-down-box [(value)]="selectedEmployee" [inputAttr]="{ 'aria-label': 'Employee Information' }"
      valueExpr="employeeId" displayExpr="employeeNameAr" [showClearButton]="true"
      placeholder="{{'choose'|translate}}  {{'hr.employeeId' | translate}}" [dataSource]="employeeinformation"
      contentTemplate="employeeContentTemplate">
      <div *dxTemplate="let e of 'employeeContentTemplate'" style="overflow-x: auto;">
        <dxo-label text="{{'hr.employeeId' | translate}}"></dxo-label>
        <dx-data-grid [dataSource]="employeeinformation" keyExpr="employeeId" [remoteOperations]="true" [height]="300"
          [selectedRowKeys]="selectedEmployee" [focusedRowEnabled]="true"
          [searchPanel]="{ visible: true, placeholder: 'Search...' }" [hoverStateEnabled]="true"
          (onSelectionChanged)="onEmployeeSelectionChanged($event.selectedRowKeys)" [columnAutoWidth]="true"
          [wordWrapEnabled]="false" [width]="'100%'" [columns]="filteredEmployeeColumns">
          <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
          <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
          <dxo-selection mode="multiple"></dxo-selection>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-header-filter [visible]="true"></dxo-header-filter>
        </dx-data-grid>
      </div>
    </dx-drop-down-box>
  </dxi-item>

</dx-form>